export class OrderError {
  type: string;
  message: string;
}
